import { Component, Inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as Constants from "../../utils/Constants";
import { StorageService } from 'src/app/services/storage.service';
import { MasterdataApiService } from 'src/app/services/masterdata-api.service';
import { TranslateService } from '@ngx-translate/core';
import { CalculationAutoUpdateService } from 'src/app/services/calculation-auto-update.service';
type ConfigType = 'basic' | 'advanced' | 'manual';

@Component({
  selector: 'app-edit-spacer',
  templateUrl: './edit-spacer.component.html',
  styleUrls: ['./edit-spacer.component.scss'],
  standalone: false
})
export class EditSpacerComponent implements OnInit {
  @Input() isComparisonMode: boolean = false;
  readonly EN_10077_CONFORM = true;

  configType: ConfigType = 'basic';
  spacerData: any[] = [];
  desiccantData: any[] = Constants.data_desiccants;
  sealantData: any[] = Constants.data_sealants;
  sealantHeightData: number[] = [2, 3, 4, 5, 6];

  selectedSpacer: string = "";
  selectedDesiccant: string = this.desiccantData[0]?.id || null;
  selectedSealant: string = this.sealantData[0]?.id || null;
  selectedSealantHeight: number = this.sealantHeightData[0];

  eManSpacerPsi: number = 0.078;
  eManSpacerFrsi: number = 0.56;
  eManSpacerName = "man";
  isFormValid = true;

  constructor(private modalController: ModalController, private storageService: StorageService,
     @Inject(MasterdataApiService) private masterdataApi: MasterdataApiService,
    private translate: TranslateService, private calcAutoUpdate: CalculationAutoUpdateService) { }

  ngOnInit() { }

  async ionViewWillEnter() {
    await this.getMasterData();
    this.init();
  }

  private async getMasterData() {
    const masterData = await this.masterdataApi.getCachedMasterData();
    this.spacerData = masterData?.spacers ?? [];
    this.selectedSpacer = this.spacerData[0]?.id || null;
  }

  private async init(): Promise<void> {
    try {
      const res = this.isComparisonMode
        ? await this.storageService.getComparedProject()
        : await this.storageService.getProject();

      let storedProject = res ? JSON.parse(res) : null;

      if (storedProject?.spacer?.id != "0") {
        this.selectedSpacer = (storedProject?.spacer?.id || this.spacerData[0]?.id).toString();
      }
      this.configType = storedProject?.windowSpacerType || "basic";

      if (storedProject?.spacerExpert) {
        const expert = storedProject.spacerExpert;

        if (expert.desiccant) {
          this.selectedDesiccant = expert.desiccant.id;
        }

        if (expert.sealant) {
          this.selectedSealant = expert.sealant.id;
        }

        if (expert.sealant?.size) {
          this.selectedSealantHeight = expert.sealant.size;
        }
      }
      console.log(this.configType, storedProject?.spacer?.id, this.selectedSpacer)
      if (this.configType == 'manual' && storedProject?.spacer?.id == '0') {
        this.eManSpacerFrsi = storedProject?.spacer?.repfrsi[0]?.values[0];
        this.eManSpacerPsi = storedProject?.spacer?.reppsi[0]?.values[0];
        this.eManSpacerName = storedProject?.spacer?.name;
      }

      console.log('Initialized sealant height:', this.selectedSealantHeight);
    } catch (error) {
      console.error('Error initializing spacer data:', error);
    }
  }

  onModeChange(event: CustomEvent) {
    const value = event.detail.value as string | undefined;
    if (value === 'basic' || value === 'advanced' || value === 'manual') {
      this.configType = value;
      this.isFormValid = true;
    }
  }
  selectBasicSpacerOpt(option: any) {
    this.selectedSpacer = option.toString();
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  private async saveToStorage(payload: any): Promise<void> {
    if (this.isComparisonMode) {
      await this.storageService.updateComparedProject(payload);
    } else {
      await this.storageService.updateProject(payload);
      await this.calcAutoUpdate.triggerAutoUpdate('spacer', this.isComparisonMode);
    }
  }

  private deepCopy(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }
  async next() {
    var selectedSpacerObj;
    if (this.selectedSpacer) {
      // selectedSpacerObj = this.findDataById(this.spacerData, this.selectedSpacer);
      selectedSpacerObj = this.deepCopy(this.findDataById(this.spacerData, this.selectedSpacer));
    }
    if (this.configType == 'basic' && this.selectedSpacer) {
      await this.saveToStorage({
        "spacer": this.findDataById(this.spacerData, this.selectedSpacer),
        "spacerExpert": null,
        "windowSpacerType": this.configType
      });
    } else if (this.configType == 'advanced' && this.selectedSealant && this.selectedDesiccant && this.selectedSpacer) {
      var selectedSealantObj = this.findDataById(this.sealantData, this.selectedSealant);
      selectedSealantObj['size'] = this.selectedSealantHeight;
      var selectedDesiccantObj = this.findDataById(this.desiccantData, this.selectedDesiccant);
      await this.saveToStorage({
        "spacer": this.findDataById(this.spacerData, this.selectedSpacer),
        "spacerExpert": {
          "sealant": selectedSealantObj,
          "desiccant": selectedDesiccantObj
        },
        "windowSpacerType": this.configType
      });
    } else if (this.configType == 'manual') {
      var spacerData: any = {};
      let psi: number = Number(this.eManSpacerPsi);
      let frsi: number = Number(this.eManSpacerFrsi);

      if (this.EN_10077_CONFORM) {
        psi = Constants.roundThreeValuePositions(psi);
        frsi = Number(frsi.toFixed(2));
      }

      selectedSpacerObj.id = '0';
      selectedSpacerObj.name = this.eManSpacerName;
      selectedSpacerObj.img = "assets/images/spacer/manual.png";
      selectedSpacerObj.isManual = true;
      selectedSpacerObj.psi = psi;

      for (let i = 0; i < selectedSpacerObj.reppsi.length; i++) {
        for (let j = 0; j < selectedSpacerObj.reppsi[i].values.length; j++) {
          selectedSpacerObj.reppsi[i].values[j] = psi;
          selectedSpacerObj.repfrsi[i].values[j] = frsi;
        }
      }


      await this.saveToStorage({
        "spacer": selectedSpacerObj,
        "spacerExpert": null,
        "windowSpacerType": this.configType
      });


    }
    this.modalController.dismiss(null, 'confirm');
  }

  validateForm(): void {
    // Check if required fields have values
    const hasName = this.eManSpacerName !== null && this.eManSpacerName !== undefined;
    const hasPsi = this.eManSpacerPsi !== null && this.eManSpacerPsi !== undefined && this.eManSpacerPsi > 0;
    const hasFrsi = this.eManSpacerFrsi !== null && this.eManSpacerFrsi !== undefined && this.eManSpacerFrsi > 0;

    this.isFormValid = hasName && hasPsi && hasFrsi;
  }

  private findDataById(arrayData: any, id: string): any {
    return arrayData.find((obj: any) => obj.id == id);
  }

  getSpacerSubLabel(name: string): string {
    const key = name?.toLowerCase();
    if (key?.includes('ultimate pro')) return this.translate.instant('with_extra_flex');
    if (key?.includes('ultimate') && key?.includes('ny')) return this.translate.instant('recycled');
    return '';
  }


}
